import Vue from 'vue'
import saveState from 'vue-save-state'

const regions = [
  { name: 'Europe West', code: 'euw' },
  { name: 'North America', code: 'na' },
  { name: 'Europe Nordic & East', code: 'eune' },
  { name: 'Oceania', code: 'oce' },
  { name: 'Latin America North', code: 'lan' },
  { name: 'Latin America South', code: 'las' },
  { name: 'Korea', code: 'kr' },
  { name: 'Japan', code: 'jp' },
  { name: 'Brazil', code: 'br' },
  { name: 'Russia', code: 'ru' },
  { name: 'Turkey', code: 'tr' },
]

let darkThemeEnabled = JSON.parse(localStorage.getItem('dark-theme-enabled')) === true

const state = new Vue({
  mixins: [saveState],

  data: {
    darkThemeEnabled,
    regions,
    selectedRegion: regions[0],
  },

  methods: {
    getSaveStateConfig () {
      return {
        'cacheKey': 'state',
        'saveProperties': ['selectedRegion'],
      }
    },
  },
})

export default state



// WEBPACK FOOTER //
// ./src/state/index.js